// extracted by mini-css-extract-plugin
module.exports = {"Img":"Img-module__Img___10Dw5","img":"Img-module__Img___10Dw5"};